<template>
    <div class="d-inline-block">
        <b-btn :disabled="!$store.getters.getCanSign" variant="custom-danger" @click="showModal = true">Отказаться от подписания контракта</b-btn>
        <b-modal v-model="showModal" centered no-close-on-backdrop no-close-on-esc scrollable size="md" title="Отказ от подписания контракта" @close="cancelSignModal">
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <form-row-edit-textarea v-if="purchaseItem.is_customer" label="Причина отказа" v-model="comment" :v="$v.comment" :rows="5" label-on-top />
            <template v-if="purchaseItem.is_supplier && purchaseItem.flags.is_first_contract">
                <h6 class="text-danger fw-600">В случае отказа от заключения контракта с лицевого счёта вашей организации будет списана комиссия в соответствии с Регламентом ИС АТМО.</h6>
            </template>
            <h6 class="text-danger fw-600">Обращаем Ваше внимание, что данное действие необратимо.</h6>
            <div slot="modal-footer" class="w-100 px-3">
                <b-button :disabled="isDataSending" variant="custom-outline-secondary" class="mr-2" @click="cancelSignModal">Отмена</b-button>
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="$v.$invalid" variant="custom-danger" @click="signDecline">Отказаться</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { minLength, requiredIf } from 'vuelidate/lib/validators';

export default {
    name: 'fl44-unknown-volume-sign-decline-contract-button',
    props: {
        purchaseItem: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showModal: false,
            isDataSending: false,
            comment: ''
        };
    },
    validations: {
        comment: {
            required: requiredIf(function() { return this.purchaseItem.is_customer }),
            minLength: minLength(10)
        }
    },
    methods: {
        cancelSignModal() {
            this.showModal = false;
        },
        async signDecline() {
            this.isDataSending = true;
            await this.$api.personal.fl44UnknownVolume
                .declineSignContract(this.purchaseItem.id, this.purchaseItem.contract.id, { comment: this.comment })
                .then((response) => {
                    if (response) {
                        this.cancelSignModal();
                        this.$emit('refresh');
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        }
    }
};
</script>
